import { combineReducers } from "redux";

import { vehicleDetails } from "./reducer.vehicle"
const vehicleReducers = combineReducers({
  vehicleDetails
})
export default vehicleReducers;
